import React from "react";

type CartRemovePopupWidgeProps = {
  showModal?: boolean;
  isEnabled?: boolean;
  Message?: string | null;
  closeModal?: () => void;
};

export default class CartRemovePopupWidge extends React.Component<CartRemovePopupWidgeProps> {
  render() {
    return (
      <>
        <div className={this.props.showModal ? "modal-backdrop fade show" : ""}></div>
        <div className={this.props.showModal ? "modal fade show" : "modal fade"} style={this.props.showModal ? { display: "block" } : { display: "none" }} id="AppOnly" aria-labelledby="ErrorModalLabel" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <button onClick={this.props.closeModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label=""></button>
              <div className="modal-body">
                <img className="img-fluid" src={"https://images.app.thefepi.com/app/S__45105162.jpg"} style={{ width: "100%", height: "300px" }} />
                <br></br>
                <h3 style={{ marginTop: "10px" }}>Factory Outlet Open!</h3>
                <p> Beyond Trends, Beyond Prices ~90% OFF</p>
                <div className="text-center">
                  <br></br>
                  <input onClick={this.props.closeModal} type="button" className="btn btn-secondary" value="TIDAK"></input>&nbsp;&nbsp;
                  <input
                    type="button"
                    className="btn btn-secondary"
                    value="DOWNLOAD"
                    formTarget="_blank"
                    onClick={() => {
                      window.location.href = window.navigator.userAgent.includes("Android") ? "https://play.google.com/store/apps/details?id=com.thefepi.shopable" : "https://apps.apple.com/id/app/thefepi/id1590816062";
                    }}
                  ></input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
